import React from "react";
import { Card, Typography } from "antd";

const ShippingPage = () => (
  <div className="policy-container">
    <Card>
      <Typography.Title level={2}>Shipping & Delivery Policy</Typography.Title>

      <Typography.Title level={4}>1. Shipping Locations</Typography.Title>
      <Typography.Paragraph>
        We ship to all serviceable pin codes in India.
      </Typography.Paragraph>

      <Typography.Title level={4}>2. Delivery Timeline</Typography.Title>
      <Typography.Paragraph>
        - Metro cities: 2–4 days<br />
        - Tier 2/3 cities: 3–7 days<br />
      </Typography.Paragraph>

      <Typography.Title level={4}>3. Tracking</Typography.Title>
      <Typography.Paragraph>
        Once shipped, tracking details will be sent via SMS/Email.
      </Typography.Paragraph>

      <Typography.Title level={4}>4. Lost / Damaged Shipments</Typography.Title>
      <Typography.Paragraph>
        Must be reported within 48 hours with images.
      </Typography.Paragraph>
    </Card>
  </div>
);

export default ShippingPage;
